module.exports = __webpack_public_path__ + "img/cockroach_redchart01.c49c9688.jpg";